import { z } from 'zod';
import { listQuerySchema } from '../common/pagination';
import { moneySchema } from '../money';

/**
 * Vertriebspipeline (ADR 0056): voraussichtlich eingehende Projekte, die noch
 * keine echten Projekte im System sind. Gepflegt im Modul Vertrieb, ausgewertet
 * im Rolling Forecast (Modul reporting): Volumen × Auftragswahrscheinlichkeit
 * im Monat des erwarteten Auftragseingangs.
 */
export const createSalesPipelineEntrySchema = z.object({
  name: z.string().trim().min(1).max(200),
  /** Gesellschaft (Soft-Ref); der Name wird serverseitig als Snapshot übernommen. */
  legalEntityId: z.string().uuid().nullable().optional(),
  /** Erwartetes Projektvolumen als Money (Mikro-Einheiten + Währung, §6). */
  volume: moneySchema.nullable().optional(),
  /** Auftragswahrscheinlichkeit in Prozent (0–100). */
  probabilityPct: z.number().int().min(0).max(100).default(50),
  /** Erwarteter Auftragseingang (ISO-Datum). */
  expectedOrderDate: z.string().datetime().nullable().optional(),
  note: z.string().trim().max(2000).nullable().optional(),
});
export type CreateSalesPipelineEntryInput = z.infer<typeof createSalesPipelineEntrySchema>;

/** Aktualisieren — alle Felder optional; `null` leert ein Feld (PATCH-Semantik). */
export const updateSalesPipelineEntrySchema = createSalesPipelineEntrySchema.partial();
export type UpdateSalesPipelineEntryInput = z.infer<typeof updateSalesPipelineEntrySchema>;

export const salesPipelineEntryResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  name: z.string(),
  legalEntityId: z.string().uuid().nullable(),
  legalEntityName: z.string().nullable(),
  volume: moneySchema.nullable(),
  probabilityPct: z.number().int(),
  expectedOrderDate: z.string().datetime().nullable(),
  note: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type SalesPipelineEntryResponse = z.infer<typeof salesPipelineEntryResponseSchema>;

/** Listen-Query (Standard §8: page/pageSize/sort/q). */
export const salesPipelineListQuerySchema = listQuerySchema;
export type SalesPipelineListQuery = z.infer<typeof salesPipelineListQuerySchema>;
